import React, {Suspense} from 'react'
import Loading from '../../../components/shared-components/Loading'
import {OrderEditionViewer} from './order-edition-viewer'

export const OrderContent = () => (
  <Suspense fallback={<Loading cover='content'/>}>
    <OrderEditionViewer/>
  </Suspense>
)
